export const groupLinkPath = '#/join-group-with-link';
